export interface User {
    username?: string;
    password?: string;
}
export interface UserResponse {
    _id: string
    firstName: string,
    middleName: string,
    lastName: string,
    role: string,
    email: string,
    profilePicture: string,
    country: any,
    state: string,
    city: string,
    zip: string,
    address: string,
    phone: string,
    companyId: string,
    status: string,
    createdAt: string,
}
export interface UserCheckout {
    firstName: string,
    middleName: string,
    lastName: string,
    phone: string,
    email: string,
    address: {
        country: string,
        street: string,
        city: string,
        state: string,
        zip: string
    },

}

export interface Address {
    street: string;
    city: string;
    state: string;
    zip: string;
    country: string;
}

export interface RegistrationUser {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    companyId?: string;
    role?: string;
    email?: string;
    phone?: string,
    status?: string,
    password?: string;
    confirmPassword?: string;
    address?: Address
}
export interface EditUser {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    status?: string;
    role?: string;
    email?: string;
    phone?: string,
    address?: Address
}
export interface UserSession {
    id: string,
    firstName?: string,
    middleName?: string,
    lastName?: string,
    role?: string,
    email?: string,
    profilePicture?: string,
    status?: string,
    creationDate?: string,
    country?: string,
    state?: string,
    city?: string,
    zip?: string,
    address?: string,
    phone?: string,
    companyId?: string,
    _id: string
}
export interface Profile {
    firstName: string,
    middleName: string,
    lastName: string,
    role: string,
    email: string,
    profilePicture: string,
    country: string,
    state: string,
    city: string,
    zip: string,
    address: string,
    phone: string,
    status: string,
    totalSubscriptionsCompleted: string,
    totalSubscriptions: string,
    creationDate: string,
    id: string,
    createdAt: string,

}
export interface ProfileEditInformation {
    id?: string,
    firstName: string,
    lastName: string
    role?: string
}
export interface Students {
    user_id: string,
    first_name: string,
    last_name: string,
    status: string,
    viewed: string,
    unviewed: string,
    total: string,
    totalExams: string,
    totalExamsPassed: string,
    creation_date: string,
    totalViews: string,
    exams: string,
    userId: string,

}

export interface ChangePasswordDto {
    password: string;
    confirmPassword: string;
    oldPassword: string;
}
export interface ForgotPasswordDto {
    email: string;
}
export class ConfirmForgotPasswordDto {
    password: string;
    confirmPassword: string;
}

export interface RegistrationStudentCourse {
    firstName?: string,
    lastName?: string,
    email?: string,
    phone?: string,
}

export interface UserInfoCourse {
    _id?:any;
    userId?: string,
    companyId?: string,
    companyName?: string,
    productName?: string,
    totalLessons?: string,
    totalComplete?: string,
    certificates?: any;
}


export enum USER_STATUS {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    INACTIVE = 'INACTIVE',
}
export enum USER_ROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    INSTRUCTOR = 'INSTRUCTOR',
    COMPANY = 'COMPANY',
}